import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const REMAINING_SPOTS = 7;
const FILLED_PERCENT = 93;
type UrgencyBlockProps = {
  showSpots?: boolean;
  showCurrency?: boolean;
};
export function UrgencyBlock({
  showSpots = true,
  showCurrency = true
}: UrgencyBlockProps) {
  return <div className="w-full rounded-2xl border border-gold/25 bg-ink-soft p-4 sm:p-5" data-id="element-240" data-mp="39xa15geeym4t">
      <CountdownTimer data-id="element-241" data-mp="34zqdxqzqmz0q" />

      {showSpots ? <div className="mt-5" data-id="element-242" data-mp="34wcasgj92ls8">
          <p className="text-center text-[13px] font-bold leading-snug text-danger" data-id="element-243" data-mp="2zzcdau0gurcq">
            Restano solo {REMAINING_SPOTS} posti al prezzo promozionale!
          </p>
          <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Posti già riservati al prezzo promozionale" data-id="element-244" data-mp="2qyxfiv6bfjsc">
            <div className="h-full rounded-full bg-danger" style={{
          width: `${FILLED_PERCENT}%`
        }} data-id="element-245" data-mp="14xx02tgjj0io" />
          </div>
          <p className="mt-2 text-center text-[11px] font-extrabold uppercase tracking-[0.14em] text-cream/55" data-id="element-246" data-mp="19y1joscqwbd4">
            {FILLED_PERCENT}% riservato
          </p>
        </div> : null}

      {showCurrency ? <p className="mt-4 flex items-start justify-center gap-2 text-center text-[12px] leading-snug text-cream/55" data-id="element-247" data-mp="100dok1b891uf">
          <GlobeIcon className="mt-px h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-248" data-mp="1smygp3zj1hz1" />
          Il cambio di valuta avviene automaticamente in base al tuo paese.
        </p> : null}
    </div>;
}